import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ListService } from '@fry/lib/list';
import { VenuesSearch } from '@fry/booking/lib';


@Component({
    selector: 'eas-venues',
    templateUrl: './venues.component.html',
    providers: [
        ListService,
        VenuesSearch,
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VenuesComponent {

  constructor(
  ) { }

}
